<template>
  <div class="workout-area">
    <span v-if="!woData" :class="isCollapsed && 'display-none'">No workouts to share.</span>
    <div v-if="woData" :class="isCollapsed && 'display-none'">
      <label>workout</label>
      <el-cascader
        style="width: 100%"
        placeholder="Pick a workout"
        id="selectedWOKey"
        v-model="selectedWOKey"
        :options="woData"
        filterable
        clearable
        @change="woSelectorOnChangeHandler"
      />
    </div>
    <div v-if="activeWorkout.name" :class="isCollapsed && 'display-none'">
      <label>Active Workout</label>
      <div style="margin: 8px 0;">{{ activeWorkout.name }}</div>
      <div>
        <el-tag>{{ activeWorkout.focus }}</el-tag> <el-tag>{{ activeWorkout.type }}</el-tag>
      </div>
    </div>
    <div class="shared-workout" :class="isCollapsed && 'collapsed'">
      <div class="shared-workout--content">
        <el-card
          v-for="(circuit, index) in activeWorkout.circuits"
          :key="index"
          shadow="never"
        >
          <div slot="header" class="circuit-header">
            <i class="el-icon-coin"></i>
            <div class="circuit-header--title">
              {{
                (circuit.cirName ? circuit.cirName + ((circuit.cirName && circuit.cirFocus) ? ' | ' : '') : 'Circuit ' + (index + 1) + ((circuit.cirFocus) ? ' | ' : '')) + 
                (circuit.cirFocus ? circuit.cirFocus + ((circuit.cirFocus && circuit.cirType) ? ' | ' : '') : '') +
                (circuit.cirType ? circuit.cirType : '')
              }}
            </div>
            <div class="description">Circuit</div>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">Next</el-button> -->
          </div>
          <div
            v-for="(exercise, index) in circuit.exercises"
            :key="index"
            class="exercises"
          >
            <div class="exercise-info">
              <div class="description">Exercise name: <span style="float: right;">{{exercise.setType}}</span></div>
              <span class="exercise-name">{{ exercise.name }} </span>
              <el-tooltip class="exercise-tooltip" v-if="exercise.exerciseDesc" effect="dark" :content="exercise.exerciseDesc" placement="right">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
            <div class="exercise-info">
              <template v-if="exercise.equipment">
                <div class="description">Equipment:</div>
                {{ exercise.equipDesc }}
              </template>
            </div>
            <div class="exercise-info">
              <div class="exercise-sets">
                <div v-if="exercise.setAmount != 0">
                  <div class="description">Set x rep amount:</div>
                  {{ exercise.setAmount }}{{ ' x ' + exercise.repAmount }}
                </div>
                <div v-if="exercise.exerciseTime != 0">
                  <div class="description">Exercise Time:</div>
                  {{ exercise.exerciseTime + ' seconds' }}
                </div>
                <div v-if="exercise.restTime != 0">
                  <div class="description">Rest Time:</div>
                  {{ exercise.restTime + ' seconds' }}
                </div>
              </div>
              <div class="exercise-sets">
                <div v-if="exercise.setAmount2 != 0">
                  <div class="description">Set x rep amount:</div>
                  {{ exercise.setAmount2 }}{{ ' x ' + exercise.repAmount2 }}
                </div>
                <div v-if="exercise.exerciseTime2 != 0">
                  <div class="description">Exercise Time:</div>
                  {{ exercise.exerciseTime + ' seconds' }}
                </div>
                <div v-if="exercise.restTime2 != 0">
                  <div class="description">Rest Time:</div>
                  {{ exercise.restTime + ' seconds' }}
                </div>
              </div>
            </div>
            <hr>
          </div>
          <div style="padding-bottom: 8px;" v-if="circuit.repeat">
            Repeat: {{circuit.repeatAmount}} {{circuit.repeatAmount > 1 ? ' times' : ' time'}}
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  data () {
    return {
      woData: '',
      selectedWOKey: this.activeWorkout.name,
      room: this.roomName
    }
  },
  props: {
    roomName: String,
    activeWorkout: Object,
    isCollapsed: Boolean
  },
  methods: {
    async woSelectorOnChangeHandler() {

      let uid = JSON.parse(localStorage.getItem('user')).uid

      // Retrieve Workouts data
      await firebase.database().ref().child(uid).child('workouts').get().then((snapshot) => {
        if (snapshot.exists()) {
          if (this.selectedWOKey != '') {
            let workouts = Object.values(snapshot.val())
            
            // find workout with this key
            let selectedWorkout = workouts.find(obj => {
              return obj.value === this.selectedWOKey[0]
            })
            firebase.database().ref('rooms/' + this.room).update({
              'selectedWorkout': selectedWorkout
            })
          } else {
            firebase.database().ref('rooms/' + this.room + '/selectedWorkout').remove()
          }
        } else {
          console.log('No workouts')
        }
      }).catch((error) => {
        console.error(error)
      })
    }
  },
  watch: {
    activeWorkout: {
      deep: true,
      handler() {console.log('activeWorkout watched')}
    }
  },
  beforeMount() {
    let uid = JSON.parse(localStorage.getItem('user')).uid

    // Retrieve Workouts data
    firebase.database().ref().child(uid).child('workouts').get().then((snapshot) => {
      if (snapshot.exists()) {
        this.woData = Object.values(snapshot.val())
      }
    }).catch((error) => {
      console.error(error)
    })
  }
}
</script>

<style>
.workout-area {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: auto;
  padding: 16px 8px;
}

.shared-workout {
  height: 100%;
  left: 316px;
  max-width: 300px;
  overflow: auto;
  position: absolute;
  scrollbar-color: transparent transparent;
  scrollbar-width: none;
  top: 0;
  transition: .15s;
  width: 300px;
  z-index: 2;
}

.shared-workout.collapsed {
  left: 66px;
}

.shared-workout::-webkit-scrollbar {
  display: none;
}

.shared-workout .shared-workout--content {
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 16px 0;
}

.shared-workout .shared-workout--content .circuit-header {
  align-items: center;
  display: flex;
}

.shared-workout .shared-workout--content .circuit-header .circuit-header--title {
  margin-left: 4px;
  margin-right: 8px;
}

.shared-workout .shared-workout--content .circuit-header .description {
  margin-left: auto;
}

.shared-workout .shared-workout--content .el-card {
  color: #000;
  font-weight: 500;
  margin-bottom: 16px;
}

.shared-workout .shared-workout--content .el-card .el-card__header,
.shared-workout .shared-workout--content .el-card .el-card__body {
  font-size: 14px;
  letter-spacing: .25px;
  padding: 8px 16px;
}

.shared-workout .shared-workout--content .el-card .el-card__body .description {
  margin-left: 0;
}

.shared-workout .shared-workout--content .el-card .el-card__body .exercises hr {
  margin: 16px 0;
}

.shared-workout .shared-workout--content .el-card .el-card__body .exercises:last-child hr {
  display: none;
}

.shared-workout .shared-workout--content .el-card .el-card__body .exercises .exercise-info {
  margin-bottom: 4px;
}

.shared-workout .shared-workout--content .el-card .el-card__body .exercises .exercise-info:last-child {
  margin-bottom: 0;
}

.shared-workout .shared-workout--content .el-card .el-card__body .exercises .exercise-info .exercise-name {
  font-size: 16px;
}

.shared-workout .shared-workout--content .el-card .el-card__body .exercises .exercise-info .exercise-sets {
  display: flex;
  flex-direction: row;
}

.shared-workout .shared-workout--content .el-card .el-card__body .exercises .exercise-info .exercise-sets:first-child {
  margin-bottom: 8px;
}

.shared-workout .shared-workout--content .el-card .el-card__body .exercises .exercise-info .exercise-sets > div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
</style>